
import React from 'react';
import { Church, Users, Globe, DollarSign } from 'lucide-react';
import { City } from '../../data/types/city-types';
import { useLanguage } from '../../contexts/language';
import { getPresenceColor, getPresenceText } from '../../utils/church-presence';

interface CityInfoContentProps {
  city: City;
}

const CityInfoContent: React.FC<CityInfoContentProps> = ({ city }) => {
  const { t } = useLanguage();

  // Ensure funding_percentage is either a valid number or 0
  const fundingPercentage = city.funding_percentage !== undefined && !isNaN(city.funding_percentage) 
    ? city.funding_percentage 
    : 0;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-gray-900">{city.name}</h3>
        <div className={`px-2 py-0.5 rounded-full text-xs text-white ${getPresenceColor(city.church_presence)}`}>
          {getPresenceText(city.church_presence, t)}
        </div>
      </div>
      <div className="text-sm text-gray-600 space-y-1">
        <div className="flex items-center space-x-2">
          <Church className="h-4 w-4 text-[#1EAEDB]" />
          <span>{t('churches')}: {city.churches_count || 0}</span>
        </div>
        <div className="flex items-center space-x-2">
          <Users className="h-4 w-4 text-[#1EAEDB]" />
          <span>{t('missionaries')}: {city.missionaries || 0}</span>
        </div>
        {city.population && (
          <div className="flex items-center space-x-2">
            <Globe className="h-4 w-4 text-[#1EAEDB]" />
            <span>{t('population')}: {city.population.toLocaleString()}</span>
          </div>
        )}
        {fundingPercentage !== undefined && (
          <div className="flex items-center space-x-2">
            <DollarSign className="h-4 w-4 text-[#1EAEDB]" />
            <span className="text-[#1EAEDB] font-medium">{t('fundingProgress')}: {fundingPercentage}%</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CityInfoContent;
